import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import amazon from '../../images/ClientReview/amazone.png';
import content from '../../images/ClientReview/content.png';
import person1 from '../../images/ClientReview/person1.png';
import person2 from '../../images/ClientReview/person2.png';
import person3 from '../../images/ClientReview/person3.png';
import product from '../../images/ClientReview/product.png';
import './ClientReview.scss';

const ClientReview = () => {
    const clientReview = [
        {
            id: 1,
            name: 'Ernie R. Miller',
            title: 'UI & UX DESIGNER',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu netus neque hendrerit sed turpis diam sodales. Purus nec pretium donec lectus facilisi odio.',
            img: person1,
            company: amazon,
        },
        {
            id: 2,
            name: 'Darren C. Bass',
            title: 'UI & UX DESIGNER',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu netus neque hendrerit sed turpis diam sodales. Purus nec pretium donec lectus facilisi odio.',
            img: person2,
            company: content,
        },
        {
            id: 3,
            name: 'Todd J. McGhee',
            title: 'UI & UX DESIGNER',
            des: 'Dolor sit amet, consectetur adipiscing elit. Suspendisse arcu netus neque hendrerit sed turpis diam sodales. Purus nec pretium donec lectus facilisi odio.',
            img: person3,
            company: product,
        },
    ];

    return (
        <section className="client-review pb-5">
            <Container>
                <div
                    className="pt-5 clients-says"
                    data-aos="zoom-out-right"
                    data-aos-duration="1500"
                >
                    <p>What our clients think about us!</p>
                    <h1>
                        What Our Client Say <br /> About Us
                    </h1>
                </div>
                <Row>
                    {clientReview.map((review) => (
                        <Col
                            lg={4}
                            md={6}
                            className="d-flex justify-content-center align-items-center"
                            key={review.id}
                        >
                            <Card
                                className="client-review-card"
                                data-aos="zoom-in"
                                data-aos-duration="1500"
                            >
                                <div className="client-review-header">
                                    <div>
                                        <img src={review.img} alt="clients" />
                                    </div>
                                    <div>
                                        <h4>{review.name}</h4>
                                        <p>{review.title}</p>
                                    </div>
                                </div>
                                <div className="client-review-details">
                                    <p>{review.des}</p>
                                    <img src={review.company} alt="company" />
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <div className="view-all-review" data-aos="fade-up" data-aos-duration="1500">
                    <button type="button" className="view-all-btn">
                        View All
                    </button>
                </div>
            </Container>
        </section>
    );
};

export default ClientReview;
